import { Component, input, output } from '@angular/core';
import { CountryDefinition, EnseigneConfig } from '../../enseigne.model';
import { TransportGroupChipsComponent } from '../transport-group-chips/transport-group-chips.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-enseigne-card',
  imports: [TransportGroupChipsComponent, MatIconModule, TranslateModule],
  templateUrl: './enseigne-card.component.html',
  styleUrl: './enseigne-card.component.scss',
})
export class EnseigneCardComponent {
  enseigne = input.required<EnseigneConfig>();

  edit = output<EnseigneConfig>();
  delete = output<string>();

  onEdit(): void {
    this.edit.emit(this.enseigne());
  }

  onDelete(): void {
    this.delete.emit(this.enseigne().codeOrg);
  }

  protected getFormattedGroupedValues(targetKey: keyof CountryDefinition): string[] {
    const values = this.enseigne()?.countriesConfig?.map((countryDef) => countryDef[targetKey]) ?? [];
    return (values as string[]).filter((value) => value != null && value.length > 0);
  }

  protected getAllTransportGroups(): string[] {
    return this.enseigne()?.countriesConfig?.flatMap((countryDef) => countryDef.transportGroups) ?? [];
  }
}
